import React, { useEffect, useState } from 'react';
import './toast.scss';
import {
  dispatch,
  ErrorVariants,
  getToast,
  hideToast,
  useAppSelector,
} from '@zonofi/zono-money-store';
import { SVGS } from '../../assets';

const ToastVariantConfig = {
  [ErrorVariants.SUCCESS]: {
    icon: SVGS.CheckDone,
  },
  [ErrorVariants.DANGER]: {
    icon: SVGS.DangerIcon,
  },
  [ErrorVariants.WARNING]: {
    icon: SVGS.DangerIcon,
  },
};

export const Toast: React.FC = () => {
  const toast = useAppSelector(getToast);
  const { canDisplay, message } = toast;
  const { icon } = ToastVariantConfig[toast?.type] || {};
  const [showToast, setShowToast] = useState(false);

  useEffect(() => {
    if (canDisplay) {
      setShowToast(true);
      const timer = setTimeout(() => {
        setShowToast(false);
        dispatch(hideToast());
      }, 3000);

      return () => clearTimeout(timer);
    } else {
      setShowToast(false);
    }
    return undefined;
  }, [canDisplay]);

  return (
    <div className={`toast-container ${showToast ? 'visible' : ''}`}>
      <div className={`toast-container-card ${toast?.type?.toLowerCase()}`}>
        <img src={icon} alt="" />
        <span className="toast-container-text font-regular">{message}</span>
      </div>
    </div>
  );
};
